module.exports = __webpack_public_path__ + "media/customizations/cannerydistrict/logo-830a739621b0e0be110ba8476fa2aa08.png";